module.exports = __webpack_public_path__ + "static/us_ccsw-c7a8966cf9516afc8cd285d9a2e9a654.png";